<template>
    <div class="designerpage">

        <wb-designer-question-door-range v-if="range_panel_required"
                                         :fabricator="fabricator"
                                         v-model:target="door.attr.door_range"
                                         :ranges="ranges"
                                         title="Choose a Door Range"
                                         :defaults="defaults()"
                                         :reference_on="reference_on"></wb-designer-question-door-range>

            <wb-designer-question-select-door :fabricator="fabricator"
                                           :secured-by-design="door.attr.secured_by_design"
                                           :door-range="door.attr.door_range"
                                           v-model:target="door.attr.slab"></wb-designer-question-select-door>

        <div class="designeroption">
            <designer-question-frame-material :slab="door.attr.slab"
                                                 :fabricator="fabricator"
                                                 v-model:target="door.attr.frame_material"></designer-question-frame-material>
        </div>

        <div>
            <wb-designer-question-select-frame-style v-if="!is_french" :fabricator="fabricator"
                                                     :is-firedoor="is_firedoorrange"
                                                     v-model:target="door.attr.frame_style"
                                                    :frame-material="door.attr.frame_material"></wb-designer-question-select-frame-style>
            <wb-french-designer-question-select-frame-style v-if="is_french" :fabricator="fabricator"
                                                            :is-firedoor="is_firedoorrange"
                                                            v-model:target="door.attr.frame_style"
                                                            :frame-material="door.attr.frame_material"></wb-french-designer-question-select-frame-style>
        </div>

        <div class="designeroption" data-designer-component-id="door_colour">
            <h3>Choose Your Door Colour</h3>

            <div class="colourtabs">
                <ul>
                    <li><a href="#dc-tabs-1">External Colour</a></li>
                    <li><a href="#dc-tabs-2">Internal Colour</a></li>
                </ul>
                <div id="dc-tabs-1">
                    <wb-designer-question-door-colour-external :fabricator="fabricator" :slab="door.attr.slab"
                                                               v-model:target="door.attr.external_colour"></wb-designer-question-door-colour-external>

                    <designer-question-ral-colour :fabricator="fabricator" :colour-id="door.attr.external_colour"
                                                  title="External Door Colour"
                                                  v-model:target="door.attr.external_colour_ral"></designer-question-ral-colour>
                </div>
                <div id="dc-tabs-2">
                    <wb-designer-question-door-colour-internal :fabricator="fabricator" :slab="door.attr.slab"
                                                               :external-colour="door.attr.external_colour"
                                                               v-model:target="door.attr.door_colour_internal"></wb-designer-question-door-colour-internal>

                    <designer-question-ral-colour :fabricator="fabricator" :colour-id="door.attr.door_colour_internal"
                                                  title="Internal Door Colour"
                                                  v-model:target="door.attr.door_colour_internal_ral"></designer-question-ral-colour>
                </div>
            </div>
        </div>

        <div class="designeroption" data-designer-component-id="frame_colour">
            <h3>Pick Your Frame Colour</h3>

            <div class="colourtabs">
                <ul>
                    <li><a href="#tabs-1">External Colour</a></li>
                    <li><a href="#tabs-2">Internal Colour</a></li>
                </ul>
                <div id="tabs-1">
                    <wb-designer-question-frame-colour-external :fabricator="fabricator"
                                                                :frame-material="door.attr.frame_material"
                                                                :slab="door.attr.slab"
                                                                :profile="door.attr.profile"
                                                                v-model:target="door.attr.frame_colour_external"></wb-designer-question-frame-colour-external>

                    <designer-question-ral-colour :fabricator="fabricator" :colour-id="door.attr.frame_colour_external"
                                                  title="External Frame Colour"
                                                  v-model:target="door.attr.frame_colour_external_ral"></designer-question-ral-colour>
                </div>
                <div id="tabs-2">
                    <wb-designer-question-frame-colour-internal :fabricator="fabricator"
                                                                :frame-material="door.attr.frame_material"
                                                                :frame-colour-external="door.attr.frame_colour_external"
                                                                :slab="door.attr.slab"
                                                                :profile="door.attr.profile"
                                                                v-model:target="door.attr.frame_colour_internal"></wb-designer-question-frame-colour-internal>

                    <designer-question-ral-colour :fabricator="fabricator" :colour-id="door.attr.frame_colour_internal"
                                                  title="Internal Frame Colour"
                                                  v-model:target="door.attr.frame_colour_internal_ral"></designer-question-ral-colour>
                </div>
            </div>
        </div>

        <div>
            <wb-designer-question-secured-by-design v-if="!no_sbd" :fabricator="fabricator"
                                                    v-model:target="door.attr.secured_by_design"></wb-designer-question-secured-by-design>

            <wb-designer-question-door-glass-laminated :fabricator="fabricator"
                                                       title="Laminated Glass:"
                                                       :slab="door.attr.slab"
                                                       :frame-style="door.attr.frame_style"
                                                       :side-panels="door.attr.side_panels"
                                                       :secured-by-design="door.attr.secured_by_design"
                                                       :is-firedoor="is_firedoorrange"
                                                       v-model:target="door.attr.laminated_glass"></wb-designer-question-door-glass-laminated>
        </div>

        <div>
            <wb-designer-question-glass-design :fabricator="fabricator"
                                               v-model:target="door.attr.glass_design"
                                               :laminated-glass="door.attr.laminated_glass"
                                               :door-range="door.attr.door_range"
                                               :slab="door.attr.slab"></wb-designer-question-glass-design>

            <designer-question-glass-text v-model:target="door.attr.glass_text"
                                               :glass-design="door.attr.glass_design"></designer-question-glass-text>
        </div>

        <wb-designer-question-glass-backing-design :fabricator="fabricator"
                                                   v-model:target="door.attr.glass_backing_design"
                                                   :slab="door.attr.slab"
                                                   :glass-design="door.attr.glass_design"></wb-designer-question-glass-backing-design>

        <wb-designer-question-select-frame-sidepanels :fabricator="fabricator"
                                                      v-model:target="door.attr.side_panels"
                                                      :door-range="door.attr.door_range"
                                                      :frame-style="door.attr.frame_style"
                                                      :frame-profile="door.attr.profile"
                                                      :frame-material="door.attr.frame_material"
                                                      :laminated-glass="door.attr.laminated_glass"
                                                      :frame-colour-internal="door.attr.frame_colour_internal"
                                                      :frame-colour-external="door.attr.frame_colour_external"
                                                      :secured-by-design="door.attr.secured_by_design"
                                                      :slab="door.attr.slab"
                                                      :measurements.sync="door.attr.measurements"></wb-designer-question-select-frame-sidepanels>

        <div class="designeroption" v-if="!is_french">
            <designer-question-hinge-side :fabricator="fabricator"
                                          v-model:target="door.attr.hinge_side"></designer-question-hinge-side>
        </div>

        <div class="designeroption">
            <designer-question-opening-direction :fabricator="fabricator"
                                                 v-model:target="door.attr.opening_direction"
                                                 :frame-combination="door.attr.frame_style.frame_id"></designer-question-opening-direction>
        </div>

        <div class="designeroption" v-if="is_french">
            <wb-designer-question-french-master :fabricator="fabricator"
                                                title="Select Your Master Door"
                                                v-model:target="door.attr.french_master"></wb-designer-question-french-master>
        </div>

        <div>
            <wb-designer-question-hardware-suite-selector v-if="!is_firedoorrange"
                                             :fabricator="fabricator"
                                             v-model:target="door.attr.suite"
                                             :door-range="door.attr.door_range"
                                             :slab="door.attr.slab"
                                             :secured-by-design="door.attr.secured_by_design"
                                             :opening-direction="door.attr.opening_direction"
                                             :profile="door.attr.profile"></wb-designer-question-hardware-suite-selector>
        </div>

        <div>

            <wb-designer-question-hardware-colour-with-suite :fabricator="fabricator"
                                                             v-model:target="door.attr.hardware_colour"
                                                             :sbd="door.attr.secured_by_design"
                                                             :slab="door.attr.slab"
                                                             :hardware-suite="door.attr.suite"
                                                             :door-range="door.attr.door_range"
                                                             :profile="door.attr.profile"
                                                             :opening-direction="door.attr.opening_direction"></wb-designer-question-hardware-colour-with-suite>
        </div>
        <div>
            <wb-designer-question-hardware-handle-with-suite v-show="!is_firedoorrange" :fabricator="fabricator"
                                                             v-model:target="door.attr.hardware_handle"
                                                             :slab="door.attr.slab"
                                                             :secured-by-design="door.attr.secured_by_design"
                                                             :opening-direction="door.attr.opening_direction"
                                                             :hardware-colour="door.attr.hardware_colour"
                                                             :hardware-suite="door.attr.suite"
                                                             :door-range="door.attr.door_range"
                                                             :profile="door.attr.profile"></wb-designer-question-hardware-handle-with-suite>
            <wb-designer-question-hardware-handle v-show="is_firedoorrange" :fabricator="fabricator"
                                                  v-model:target="door.attr.hardware_handle"
                                                  :slab="door.attr.slab"
                                                  :secured-by-design="door.attr.secured_by_design"
                                                  :opening-direction="door.attr.opening_direction"
                                                  :hardware-colour="door.attr.hardware_colour"
                                                  :hardware-suite="door.attr.suite"
                                                  :door-range="door.attr.door_range"
                                                  :profile="door.attr.profile"></wb-designer-question-hardware-handle>
            <wb-designer-question-hardware-handle-slave-with-suite v-if="is_french" :fabricator="fabricator"
                                                                   title="Select Your Slave Handle"
                                                                   v-model:target="door.attr.hardware_handle_slave"
                                                                   :hardware-handle="door.attr.hardware_handle"
                                                                   :slab="door.attr.slab"
                                                                   :secured-by-design="door.attr.secured_by_design"
                                                                   :opening-direction="door.attr.opening_direction"
                                                                   :hardware-colour="door.attr.hardware_colour"
                                                                   :hardware-suite="door.attr.suite"
                                                                   :door-range="door.attr.door_range"
                                                                   :profile="door.attr.profile"></wb-designer-question-hardware-handle-slave-with-suite>

            <designer-question-hardware-handle-split-spindle :fabricator="fabricator"
                                                             v-model:target="door.attr.hardware_handle_split_spindle"
                                                             :hardware-handle="door.attr.hardware_handle"
                                                             :slab="door.attr.slab"></designer-question-hardware-handle-split-spindle>
        </div>
        <div>
            <wb-designer-question-hardware-escutcheon :fabricator="fabricator"
                                                      v-model:target="door.attr.hardware_escutcheon"
                                                      :slab="door.attr.slab"
                                                      :secured-by-design="door.attr.secured_by_design"
                                                      :hardware-colour="door.attr.hardware_colour"
                                                      :hardware-handle="door.attr.hardware_handle"
                                                      :door-range="door.attr.door_range"
                                                      :profile="door.attr.profile"></wb-designer-question-hardware-escutcheon>

            <wb-designer-question-hardware-escutcheon-position :fabricator="fabricator"
                                                            v-model:target="door.attr.hardware_escutcheon_pos"
                                                            :slab="door.attr.slab"
                                                            :frame-material="door.attr.frame_material"
                                                            :hardware-escutcheon="door.attr.hardware_escutcheon"
                                                            :door-range="door.attr.door_range"></wb-designer-question-hardware-escutcheon-position>
        </div>

        <div v-if="is_stable">
            <wb-designer-question-hardware-escutcheon-stable :fabricator="fabricator"
                                                             title="Stable Bottom Leaf Escutcheon"
                                                              v-model:target="door.attr.hardware_escutcheon_stable"
                                                              :slab="door.attr.slab"
                                                              :secured-by-design="door.attr.secured_by_design"
                                                              :hardware-colour="door.attr.hardware_colour"
                                                              :hardware-handle="door.attr.hardware_handle"
                                                              :hardware-escutcheon="door.attr.hardware_escutcheon"
                                                             :door-range="door.attr.door_range"></wb-designer-question-hardware-escutcheon-stable>

            <wb-designer-question-hardware-escutcheon-stable-position :fabricator="fabricator"
                                                            v-model:target="door.attr.hardware_escutcheon_stable_pos"
                                                            :slab="door.attr.slab"
                                                            :frame-material="door.attr.frame_material"
                                                            :hardware-escutcheon="door.attr.hardware_escutcheon_stable"
                                                                   :door-range="door.attr.door_range"></wb-designer-question-hardware-escutcheon-stable-position>
        </div>

        <div>
            <wb-designer-question-hardware-lock :fabricator="fabricator"
                                             v-model:target="door.attr.hardware_lock"
                                             :secured-by-design="door.attr.secured_by_design"
                                             :hinge-side="door.attr.hinge_side"
                                             :slab="door.attr.slab"
                                             :frame-material="door.attr.frame_material"
                                             :hardware-handle="door.attr.hardware_handle"
                                                :opening_direction="door.attr.opening_direction"
                                             :hardware-escutcheon="door.attr.hardware_escutcheon"
                                                :door-range="door.attr.door_range"></wb-designer-question-hardware-lock>
        </div>

        <div v-show="technical_should_show">
            <wb-designer-question-hardware-cylinder :fabricator="fabricator"
                                                    title="Choose Your Cylinder"
                                                    v-model:target="door.attr.hardware_cylinder"
                                                    :slab="door.attr.slab"
                                                    :secured-by-design="door.attr.secured_by_design"
                                                    :hardware-lock="door.attr.hardware_lock"
                                                    :hardware-colour="door.attr.hardware_colour"
                                                    :opening_direction="door.attr.opening_direction"
                                                    :hardware-handle="door.attr.hardware_handle"
                                                    :door-range="door.attr.door_range"></wb-designer-question-hardware-cylinder>

            <wb-designer-question-hardware-cylinder-stable v-show="is_stablerange" :fabricator="fabricator"
                                                    title="Stable Bottom Leaf Cylinder"
                                                    v-model:target="door.attr.hardware_cylinder_stable"
                                                    :slab="door.attr.slab"
                                                    :secured-by-design="door.attr.secured_by_design"
                                                    :hardware-lock="door.attr.hardware_lock"
                                                    :hardware-colour="door.attr.hardware_colour"
                                                    :hardware-handle="door.attr.hardware_handle"
                                                    :hardware-cylinder="door.attr.hardware_cylinder"
                                                           :door-range="door.attr.door_range"></wb-designer-question-hardware-cylinder-stable>

            <designer-question-hardware-cylinder-guard :fabricator="fabricator"
                                                       v-model:target="door.attr.hardware_cylinder_guard"
                                                       :secured-by-design="door.attr.secured_by_design"
                                                       :hardware-cylinder="door.attr.hardware_cylinder"
                                                       :hardware-colour="door.attr.hardware_colour"></designer-question-hardware-cylinder-guard>
        </div>

        <div v-if="is_stable">
            <wb-designer-question-hardware-joining-bolt :fabricator="fabricator"
                                                        title="Choose your Rack Bolt"
                                                        v-model:target="door.attr.hardware_joining_bolt"
                                                        :slab="door.attr.slab"
                                                        :door-range="door.attr.door_range"></wb-designer-question-hardware-joining-bolt>

            <wb-designer-question-hardware-joining-bolt-position :fabricator="fabricator"
                                                              v-model:target="door.attr.hardware_joining_bolt_pos"
                                                              :slab="door.attr.slab"
                                                              :frame-material="door.attr.frame_material"
                                                              :hardware-joining-bolt="door.attr.hardware_joining_bolt"
                                                              :door-range="door.attr.door_range"></wb-designer-question-hardware-joining-bolt-position>
        </div>

        <div>
            <wb-designer-question-hardware-letterbox :fabricator="fabricator"
                                                     v-model:target="door.attr.hardware_letterbox"
                                                     :slab="door.attr.slab"
                                                     :side-panels="door.attr.side_panels"
                                                     :frame-id="door.attr.frame_style.frame_id"
                                                     :hardware-handle="door.attr.hardware_handle"
                                                     :hardware-colour="door.attr.hardware_colour"
                                                     :door-range="door.attr.door_range"></wb-designer-question-hardware-letterbox>

            <wb-designer-question-hardware-letterbox-position :fabricator="fabricator"
                                                           v-model:target="door.attr.hardware_letterbox_pos"
                                                           :slab="door.attr.slab"
                                                           :side-panels="door.attr.side_panels"
                                                           :frame-id="door.attr.frame_style.frame_id"
                                                           :frame-material="door.attr.frame_material"
                                                           :hardware-letterbox="door.attr.hardware_letterbox"
                                                           :door-range="door.attr.door_range"></wb-designer-question-hardware-letterbox-position>
        </div>

        <div v-if="!is_stable">
            <wb-designer-question-hardware-knocker :fabricator="fabricator"
                                                   v-model:target="door.attr.hardware_knocker"
                                                   :slab="door.attr.slab"
                                                   :hardware-handle="door.attr.hardware_handle"
                                                   :hardware-spyhole="door.attr.hardware_spy_hole"
                                                   :hardware-colour="door.attr.hardware_colour"
                                                   :door-range="door.attr.door_range"></wb-designer-question-hardware-knocker>

            <wb-designer-question-hardware-knocker-position :fabricator="fabricator"
                                                         v-model:target="door.attr.hardware_knocker_pos"
                                                         :slab="door.attr.slab"
                                                         :frame-material="door.attr.frame_material"
                                                         :hardware-knocker="door.attr.hardware_knocker"
                                                         :door-range="door.attr.door_range"></wb-designer-question-hardware-knocker-position>
        </div>

        <div>
            <wb-designer-question-hardware-spy-hole :fabricator="fabricator"
                                                    v-model:target="door.attr.hardware_spy_hole"
                                                    :slab="door.attr.slab"
                                                    :secured-by-design="door.attr.secured_by_design"
                                                    :glass-design="door.attr.glass_design"
                                                    :hardware-handle="door.attr.hardware_handle"
                                                    :hardware-knocker="door.attr.hardware_knocker"
                                                    :hardware-colour="door.attr.hardware_colour"
                                                    :door-range="door.attr.door_range"></wb-designer-question-hardware-spy-hole>

            <wb-designer-question-hardware-spy-hole-position :fabricator="fabricator"
                                                          v-model:target="door.attr.hardware_spy_hole_pos"
                                                          :slab="door.attr.slab"
                                                          :frame-material="door.attr.frame_material"
                                                          :hardware-spy-hole="door.attr.hardware_spy_hole"
                                                          :door-range="door.attr.door_range"></wb-designer-question-hardware-spy-hole-position>
        </div>

        <div>
            <wb-designer-question-hardware-cat-flap :fabricator="fabricator"
                                                    v-model:target="door.attr.hardware_cat_flap"
                                                    :slab="door.attr.slab"
                                                    :secured-by-design="door.attr.secured_by_design"
                                                    :door-range="door.attr.door_range"></wb-designer-question-hardware-cat-flap>

            <wb-designer-question-hardware-cat-flap-position :fabricator="fabricator"
                                                             v-model:target="door.attr.hardware_cat_flap_pos"
                                                             :slab="door.attr.slab"
                                                             :frame-material="door.attr.frame_material"
                                                             :hardware-cat-flap="door.attr.hardware_cat_flap"
                                                             :door-range="door.attr.door_range"></wb-designer-question-hardware-cat-flap-position>
        </div>

        <div v-show="!is_firedoorrange && !is_stable">
            <wb-designer-question-hardware-security-chain :fabricator="fabricator"
                                                       :secured-by-design="door.attr.secured_by_design"
                                                       v-model:target="door.attr.hardware_security_chain"
                                                       :hardware-colour="door.attr.hardware_colour"
                                                          :door-range="door.attr.door_range"></wb-designer-question-hardware-security-chain>
        </div>

        <div>
            <wb-designer-question-hardware-hinge  v-show="technical_should_show" :fabricator="fabricator"
                                                  v-model:target="door.attr.hardware_hinge"
                                                  :slab="door.attr.slab"
                                                  :opening_direction="door.attr.opening_direction"
                                                  :secured-by-design="door.attr.secured_by_design"
                                                  :hardware-colour="door.attr.hardware_colour"
                                                  :hinge-side="door.attr.hinge_side"
                                                  :frame-material="door.attr.frame_material"
                                                  :frame-profile="door.attr.profile"
                                                  :door-range="door.attr.door_range"></wb-designer-question-hardware-hinge>
        </div>
        <wb-designer-question-technical-profile :fabricator="fabricator"
                                                :frame-colour-internal="door.attr.frame_colour_internal"
                                                :frame-colour-external="door.attr.frame_colour_external"
                                                :frame-material="door.attr.frame_material"
                                                :secured-by-design="door.attr.secured_by_design"
                                                :hardware-handle="door.attr.hardware_handle"
                                                :hardware-escutcheon="door.attr.hardware_escutcheon"
                                                :opening-direction="door.attr.opening_direction"
                                                v-model:target="door.attr.profile"></wb-designer-question-technical-profile>

        <div v-show="false">
            <designer-question-slab-edge-profile-colour :fabricator="fabricator"
                                                        v-model:target="door.attr.slab_edge_colour"
                                                        :colour-internal="door.attr.door_colour_internal"
                                                        :colour-external="door.attr.external_colour"
                                                        :hardware-lock="door.attr.hardware_lock"
                                                        :profile="door.attr.profile"
                                                        :slab="door.attr.slab"
                                                        :door-range="door.attr.door_range"
                                                        :opening-direction="door.attr.opening_direction"
                                                        :maintitle="'Select Slab Edging Strip Colour'"
            >
            </designer-question-slab-edge-profile-colour>
        </div>

        <div>
            <wb-designer-question-addons v-show="technical_should_show" :fabricator="fabricator"
                                         v-model:target="door.attr.addons"
                                         :frame-profile="door.attr.profile"
                                         :frame-colour-internal="door.attr.frame_colour_internal"
                                         :frame-colour-external="door.attr.frame_colour_external"></wb-designer-question-addons>
        </div>

        <div>
            <wb-designer-question-technical-threshold v-show="technical_should_show" :fabricator="fabricator"
                                                      title="Choose Your Threshold"
                                                      v-model:target="door.attr.threshold"
                                                      :frame-colour-internal="door.attr.frame_colour_internal"
                                                      :frame-colour-external="door.attr.frame_colour_external"
                                                      :opening-direction="door.attr.opening_direction"
                                                      :frame-profile="door.attr.profile"
                                                      :door-range="door.attr.door_range"></wb-designer-question-technical-threshold>

        </div>

        <div v-show="technical_should_show && !is_firedoorrange" class="designeroption">
            <h3>Select Any Required Sills</h3>
            <designer-question-technical-cill :fabricator="fabricator"
                                              v-model:target="door.attr.cill"
                                              :frame-colour-internal="door.attr.frame_colour_internal"
                                              :frame-colour-external="door.attr.frame_colour_external"
                                              :opening-direction="door.attr.opening_direction"
                                              :frame-profile="door.attr.profile"
                                              :component_id="'cill'"
            ></designer-question-technical-cill>

            <designer-question-technical-cill v-if="left_flag_sill" :fabricator="fabricator"
                                              v-model:target="door.attr.side_panels.left_flag_sill_id"
                                              :frame-colour-internal="door.attr.frame_colour_internal"
                                              :frame-colour-external="door.attr.frame_colour_external"
                                              :frame-profile="door.attr.profile"
                                              :title="'Left Sidepanel Flag'"
                                              :component_id="'left_flag_cill'"
            ></designer-question-technical-cill>

            <designer-question-technical-cill v-if="right_flag_sill" :fabricator="fabricator"
                                              v-model:target="door.attr.side_panels.right_flag_sill_id"
                                              :frame-colour-internal="door.attr.frame_colour_internal"
                                              :frame-colour-external="door.attr.frame_colour_external"
                                              :frame-profile="door.attr.profile"
                                              :title="'Right Sidepanel Flag'"
                                              :component_id="'right_flag_cill'"
            ></designer-question-technical-cill>
        </div>

        <div>
            <wb-designer-question-door-drip-colour v-show="technical_should_show" :fabricator="fabricator"
                                                   title="Choose A Door Drip colour"
                                                   :external-colour="door.attr.external_colour"
                                                   v-model:target="door.attr.door_drip_colour"
                                                   :frame-profile="door.attr.profile"></wb-designer-question-door-drip-colour>
        </div>

        <div v-if="is_stablerange">
            <div class="designeroption" data-designer-component-id="meeting_bar_style">
                <h3>Select Your Stable Meeting Styles</h3>
                <div class="stylesoption">
                    <div class="row">
                        <div class="col-md">
                            <designer-question-meeting-rail-colour
                                :fabricator="fabricator"
                                title="Bottom Meeting Style (Outside)"
                                :door-colour="door.attr.external_colour"
                                v-model:target="door.attr.meeting_bar_outside"
                                :frame-profile="door.attr.profile"
                            ></designer-question-meeting-rail-colour>
                        </div>
                        <div class="col-md">
                            <designer-question-meeting-rail-colour
                                :fabricator="fabricator"
                                title="Top Meeting Style (Inside)"
                                :door-colour="door.attr.door_colour_internal"
                                v-model:target="door.attr.meeting_bar_inside"
                                :frame-profile="door.attr.profile"
                                :meeting-rail-outside="door.attr.meeting_bar_outside"
                            ></designer-question-meeting-rail-colour>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div>
            <wb-designer-question-measurements v-show="technical_should_show" title="Enter Your Required Measurements"
                                               :fabricator="fabricator"
                                               :slab="door.attr.slab"
                                               :door-range="door.attr.door_range"
                                               :external-colour="door.attr.external_colour"
                                               :internal-colour="door.attr.door_colour_internal"
                                               :frame-profile="door.attr.profile"
                                               :threshold="door.attr.threshold"
                                               :frame-id="door.attr.frame_style.frame_id"
                                               :side-panels="door.attr.side_panels"
                                               :addons="door.attr.addons"
                                               :cill="door.attr.cill"
                                               :hardware-lock="door.attr.hardware_lock"
                                               :hardware-hinge="door.attr.hardware_hinge"
                                               :hardware-handle="door.attr.hardware_handle"
                                               :hardware-knocker="door.attr.hardware_knocker"
                                               :hardware-spy-hole="door.attr.hardware_spy_hole"
                                               :hardware-escutcheon="door.attr.hardware_escutcheon"
                                               :hardware-letterbox="door.attr.hardware_letterbox"
                                               :hardware-letterbox-position="door.attr.hardware_letterbox_pos"
                                               :mdd="mdd"
                                               :technical_should_show="technical_should_show"
                                               v-model:target="door.attr.measurements"></wb-designer-question-measurements>
        </div>

        <div>
            <wb-designer-question-technical-drainage v-show="technical_should_show" :fabricator="fabricator"
                                                  v-model:target="door.attr.drainage"
                                                  :cill="door.attr.cill"
                                                  :threshold="door.attr.threshold"></wb-designer-question-technical-drainage>
        </div>

        <div class="designeroption" v-if="reference_on" data-designer-component-id="reference">
            <h3>Enter A Door Reference</h3>
            <div class="stylesoption">
                <div class="form-group">
                    <input dusk="door_reference" type="text" v-model="door.attr.reference" class="form-control">
                </div>
            </div>
        </div>
        <input v-else dusk="door_reference" type="hidden" v-model="door.attr.reference" class="form-control" value="Retail Door">

        <designer-question-notes v-model:target="door.attr.notes"></designer-question-notes>

      <designer-navigation
          v-if="show_navigation"
          :visible_designer_configurator_components="visible_designer_configurator_components"
          transition="designer-navigation"
      ></designer-navigation>

    </div>

</template>

<script type="text/ecmascript-6">
    import DoorConfigurator from "../DoorConfigurator.vue";

    export default {
        mixins: [
            DoorConfigurator
        ],
        computed: {
            is_firedoorrange(){
                return this.door.attr.door_range === 10;
            },
            is_virtualrange(){
                return this.door.attr.door_range === 18;
            },
            is_stablerange(){
                return this.door.attr.door_range === 37;
            },
            no_sbd(){
                return this.door.attr.frame_material === 5 ||
                    this.door.attr.door_range === 18 ||
                    this.door.attr.door_range === 37 ||
                    this.door.attr.door_range === 10 ||
                    this.door.attr.door_range === 56;
            },
            is_french(){
                return this.door_type === 'french';
            },
            is_stable(){
                return this.door_type === 'stable';
            }
        },
        watch: {
            no_sbd: function (newValue) {
                if (newValue === true) {
                    this.door.attr.secured_by_design = 1;
                }
            }
        },
        methods: {
            defaults() {
                return {
                    8: {
                        "attr": {
                            "fabricator": 4,
                            "door_range": 8,
                            "suite": 49,
                            "frame_colour_external": 1,
                            "door_colour_internal": 1,
                            "door_drip_colour": 1,
                            "external_colour": 1,
                            "frame_colour_internal": 1,
                            "frame_material": 1,
                            "glass_design": 1,
                            "glass_text": "",
                            "hardware_colour": 22,
                            "hardware_handle": 363,
                            "hardware_handle_split_spindle": 424,
                            "hardware_hinge": 375,
                            "hinge_side": 1,
                            "opening_direction": 1,
                            "secured_by_design": 1,
                            "slab": 165,
                            "frame_style": {"frame_id": 1, "checkedPanels": []},
                            "laminated_glass": 1,
                            "hardware_lock": 393,
                            "hardware_cylinder": 2268,
                            "hardware_security_chain": 317,
                            "hardware_letterbox": 318,
                            "hardware_knocker": 315,
                            "hardware_spy_hole": 316,
                            "profile": 3519,
                            "threshold": 3521,
                            "side_panels": {
                                "left_composite_id": 192,
                                "right_composite_id": 192,
                                "left": 1,
                                "right": 1,
                                "left_panel_glass_id": 19,
                                "right_panel_glass_id": 19,
                                "top_panel_glass_id": 19,
                                "left_composite_glass_id": null,
                                "right_composite_glass_id": null
                            },
                            "numerals": [326, 326, 326, 326],
                            "addons": {
                                "left": {},
                                "right": {},
                                "top": {},
                                "bottom": {},
                            },
                            "cill": 3487,
                            "drainage": 1,
                            "measurements": {"overall_width": null, "overall_height": null, "left_width": null, "right_width": null, "top_box_drop": null},
                            "hardware_cat_flap": 1917,
                            "frame_finish": 1,
                            "slab_edge_colour": 150009,
                            "reference": "",
                            "notes": ""
                        }
                    },
                    9: {
                        "attr": {
                            "fabricator": 4,
                            "door_range": 9,
                            "suite": 49,
                            "frame_colour_external": 1,
                            "door_colour_internal": 1,
                            "door_drip_colour": 59,
                            "external_colour": 1,
                            "frame_colour_internal": 1,
                            "frame_material": 1,
                            "glass_design": 162,
                            "glass_text": "",
                            "hardware_colour": 22,
                            "hardware_handle": 363,
                            "hardware_hinge": 375,
                            "hinge_side": 1,
                            "opening_direction": 1,
                            "secured_by_design": 1,
                            "slab": 214,
                            "frame_style": {"frame_id": 1, "checkedPanels": []},
                            "laminated_glass": 1,
                            "hardware_lock": 393,
                            "hardware_cylinder": 503,
                            "hardware_security_chain": 317,
                            "hardware_letterbox": 318,
                            "hardware_knocker": 315,
                            "hardware_spy_hole": 316,
                            "hardware_cat_flap": 1917,
                            "profile": 3519,
                            "threshold": 3521,
                            "side_panels": {
                                "left_composite_id": null,
                                "right_composite_id": null,
                                "left": 1,
                                "right": 1,
                                "left_panel_glass_id": 19,
                                "right_panel_glass_id": 19,
                                "top_panel_glass_id": 19,
                                "left_composite_glass_id": null,
                                "right_composite_glass_id": null
                            },
                            "numerals": [326, 326, 326, 326],
                            "addons": {
                                "left": {},
                                "right": {},
                                "top": {},
                                "bottom": {},
                            },
                            "cill": 3487,
                            "drainage": 1,
                            "measurements": {"overall_width": null, "overall_height": null, "left_width": null, "right_width": null, "top_box_drop": null},
                            "frame_finish": 1,
                            "hardware_handle_split_spindle": 424,
                            "slab_edge_colour": 150009,
                            "hardware_cylinder_guard": 753,
                            "reference": "",
                            "notes": ""
                        }
                    },
                    10: {
                        "attr": {
                            "fabricator": 4,
                            "door_range": 10,
                            "frame_colour_external": 1,
                            "door_colour_internal": 1,
                            "door_drip_colour": 1,
                            "external_colour": 1,
                            "frame_colour_internal": 1,
                            "frame_material": 3,
                            "glass_text": "",
                            "hardware_colour": 64,
                            "hardware_handle": 413,
                            "hardware_hinge": 414,
                            "hinge_side": 1,
                            "opening_direction": 1,
                            "secured_by_design": 1,
                            "slab": 219,
                            "frame_style": {"frame_id": 31, "checkedPanels": []},
                            "laminated_glass": 1,
                            "hardware_lock": 396,
                            "hardware_cylinder": 449,
                            "hardware_security_chain": 317,
                            "hardware_letterbox": 318,
                            "hardware_knocker": 315,
                            "hardware_spy_hole": 316,
                            "hardware_cat_flap": 1917,
                            "profile": 4221,
                            "threshold": 4224,
                            "side_panels": {
                                "left_composite_id": null,
                                "right_composite_id": null,
                                "left": 1,
                                "right": 1,
                                "left_panel_glass_id": 24,
                                "right_panel_glass_id": 24,
                                "top_panel_glass_id": 24,
                                "left_composite_glass_id": null,
                                "right_composite_glass_id": null
                            },
                            "numerals": [326, 326, 326, 326],
                            "addons": {
                                "left": {},
                                "right": {},
                                "top": {},
                                "bottom": {},
                            },
                            "cill": 3487,
                            "drainage": 1,
                            "measurements": {"overall_width": null, "overall_height": null, "left_width": null, "right_width": null, "top_box_drop": null},
                            "reference": '',
                            "notes": '',
                        }
                    },
                    18: {
                        "attr": {
                            "fabricator": 4,
                            "door_range": 18,
                            "suite": 49,
                            "frame_colour_external": 1,
                            "door_colour_internal": 105,
                            "door_drip_colour": 105,
                            "external_colour": 105,
                            "frame_colour_internal": 1,
                            "frame_material": 1,
                            "glass_design": 1,
                            "glass_text": "",
                            "hardware_colour": 22,
                            "hardware_handle": 363,
                            "hardware_hinge": 375,
                            "hinge_side": 1,
                            "opening_direction": 1,
                            "secured_by_design": 1,
                            "slab": 302,
                            "frame_style": {"frame_id": 1, "checkedPanels": []},
                            "laminated_glass": 1,
                            "hardware_lock": 393,
                            "hardware_cylinder": 2268,
                            "hardware_security_chain": 317,
                            "hardware_letterbox": 318,
                            "hardware_knocker": 315,
                            "hardware_spy_hole": 316,
                            "hardware_cat_flap": 1917,
                            "profile": 3519,
                            "threshold": 3521,
                            "side_panels": {
                                "left_composite_id": null,
                                "right_composite_id": null,
                                "left": 1,
                                "right": 1,
                                "left_panel_glass_id": 19,
                                "right_panel_glass_id": 19,
                                "top_panel_glass_id": 19,
                                "left_composite_glass_id": null,
                                "right_composite_glass_id": null
                            },
                            "numerals": [326, 326, 326, 326],
                            "addons": {
                                "left": {},
                                "right": {},
                                "top": {},
                                "bottom": {},
                            },
                            "cill": 3487,
                            "drainage": 1,
                            "measurements": {"overall_width": null, "overall_height": null, "left_width": null, "right_width": null, "top_box_drop": null},
                            "hardware_handle_split_spindle": 424,
                            "frame_finish": 1,
                            "slab_edge_colour": 168348,
                            "reference": "",
                            "notes": ""
                        }
                    },
                    37: {
                        "attr": {
                            "fabricator": 4,
                            "door_range": 37,
                            "suite": 49,
                            "frame_colour_external": 1,
                            "door_colour_internal": 1,
                            "door_drip_colour": 1,
                            "external_colour": 1,
                            "frame_colour_internal": 1,
                            "frame_material": 1,
                            "glass_design": 1,
                            "glass_text": "",
                            "hardware_colour": 22,
                            "hardware_handle": 1293,
                            "hardware_hinge": 1313,
                            "hinge_side": 1,
                            "opening_direction": 1,
                            "secured_by_design": 1,
                            "slab": 806,
                            "frame_style": {"frame_id": 1, "checkedPanels": []},
                            "laminated_glass": 1,
                            "hardware_lock": 1286,
                            "hardware_cylinder": 2270,
                            "hardware_security_chain": 317,
                            "hardware_letterbox": 318,
                            "hardware_knocker": 315,
                            "hardware_spy_hole": 316,
                            "profile": 3519,
                            "threshold": 3521,
                            "side_panels": {
                                "left_composite_id": null,
                                "right_composite_id": null,
                                "left": 1,
                                "right": 1,
                                "left_panel_glass_id": 19,
                                "right_panel_glass_id": 19,
                                "top_panel_glass_id": 19,
                                "left_composite_glass_id": null,
                                "right_composite_glass_id": null
                            },
                            "numerals": [326, 326, 326, 326],
                            "addons": {
                                "left": {},
                                "right": {},
                                "top": {},
                                "bottom": {},
                            },
                            "cill": 3487,
                            "drainage": 1,
                            "measurements": {"overall_width": null, "overall_height": null, "left_width": null, "right_width": null, "top_box_drop": null},
                            "hardware_escutcheon_stable": 1191,
                            "hardware_joining_bolt": 1283,
                            "meeting_bar_outside": 1,
                            "hardware_cylinder_stable": 2271,
                            "hardware_cat_flap": 1917,
                            "hardware_joining_bolt_pos": 15067,
                            "hardware_escutcheon_stable_pos": 15064,
                            "meeting_bar_inside": 1,
                            "frame_finish": 1,
                            "slab_edge_colour": 150009,
                            "reference": "",
                            "notes": ""
                        }
                    },
                    56: {
                        "attr": {
                            "fabricator": 4,
                            "door_range": 56,
                            "suite": 49,
                            "frame_colour_external": 1,
                            "door_colour_internal": 1,
                            "door_drip_colour": 1,
                            "external_colour": 1,
                            "frame_colour_internal": 1,
                            "frame_material": 1,
                            "french_master": 1,
                            "glass_design": 1,
                            "glass_text": "",
                            "hardware_colour": 22,
                            "hardware_handle": 363,
                            "hardware_handle_slave": 1728,
                            "hardware_handle_split_spindle": 424,
                            "hardware_hinge": 375,
                            "hinge_side": 1,
                            "opening_direction": 1,
                            "secured_by_design": 1,
                            "slab": 165,
                            "frame_style": {"frame_id": 1, "checkedPanels": []},
                            "laminated_glass": 1,
                            "hardware_lock": 1723,
                            "hardware_cylinder": 2272,
                            "hardware_security_chain": 317,
                            "hardware_letterbox": 318,
                            "hardware_knocker": 315,
                            "hardware_spy_hole": 316,
                            "hardware_cat_flap": 1917,
                            "profile": 3519,
                            "threshold": 3521,
                            "side_panels": {
                                "left_composite_id": 192,
                                "right_composite_id": 192,
                                "left": 1,
                                "right": 1,
                                "left_panel_glass_id": 19,
                                "right_panel_glass_id": 19,
                                "top_panel_glass_id": 19,
                                "left_composite_glass_id": null,
                                "right_composite_glass_id": null
                            },
                            "numerals": [326, 326, 326, 326],
                            "addons": {
                                "left": {},
                                "right": {},
                                "top": {},
                                "bottom": {},
                            },
                            "cill": 3487,
                            "drainage": 1,
                            "measurements": {"overall_width": null, "overall_height": null, "left_width": null, "right_width": null, "top_box_drop": null},
                            "frame_finish": 1,
                            "slab_edge_colour": 150009,
                            "reference": "",
                            "notes": ""
                        }
                    }
                };
            }
        }
    }
</script>
